import { render, staticRenderFns } from "./SettingsAboutView.vue?vue&type=template&id=7e1b74fb&"
import script from "./SettingsAboutView.vue?vue&type=script&lang=js&"
export * from "./SettingsAboutView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAboutView.vue?vue&type=style&index=0&id=7e1b74fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports